import { Auth, Hub } from 'aws-amplify';
import { logger } from '../utils';

export interface User { signInUserSession: { idToken: { jwtToken: string } } }

export class Session {
    hubListen() {
        this.notifyUserUpdate();

        Hub.listen("auth", ({ payload: { event, data } }) => {
            logger.info('Hub auth event', event, data)
            this.notifyUserUpdate();
        });
    }

    currentValue: User | null = null;
    nextId = 0
    subscriptions: { [key: string]: any } = {}

    private notifyUserUpdate() {
        this.currentUser()
            .then(user => {
                this.currentValue = user;
                Object.keys(this.subscriptions)
                    .forEach(key => this.subscriptions[key](user));
            })
            .catch(err => {
                this.currentValue = null;
                Object.keys(this.subscriptions)
                    .forEach(key => this.subscriptions[key](null));
            });
    }

    public onUserUpdated(fn: (user: User | null) => void) {
        try {
            fn(this.currentValue);
            const id = this.nextId++;
            this.subscriptions[id] = fn;
            return () => delete this.subscriptions[id];
        } catch (e) {
            console.error('error adding subscription', e);
            return () => { };
        }
    }

    public signOut() {
        return Auth.signOut()
    }

    public hostedUI() {
        Auth.federatedSignIn();
    }

    public async currentUser(): Promise<User | null> {
        try {
            const user = await Auth.currentAuthenticatedUser();
            return user;
        } catch (e) {
            let loc = localStorage.getItem('testIdToken');
            if (!!loc) {
                if (loc.startsWith('Bearer ')) {
                    loc = loc.substring('Bearer '.length)
                }

                return {
                    signInUserSession: {
                        idToken: {
                            jwtToken: loc
                        }
                    }
                }
            }
            return null
        }
    }
}
